import React from 'react';
import { Button, Modal } from 'antd';
import { CloseCircle } from 'iconsax-react';

const ConfirmModel = (props) => {

  const { ConfirmModalOpen, ConfirmModalCloseEvent } = props;

  return (
    <>
      <Modal visible={ConfirmModalOpen} width={380} centered footer={''} closable={false} onCancel={ConfirmModalCloseEvent} getPopupContainer={node => node.parentNode} className="remove-cart-modal">
        <div className="">
          <div className="modal-header flex_item_ce mb-2">
            <button className="close-modal-btn" onClick={ConfirmModalCloseEvent}><CloseCircle size="24" color="#0000004d" /></button>
          </div>
          <div className="tm-modal-body data-loader">
            {/* <DataLoader /> */}
            <div className="tranfer-modal-data">
              <div className="confirm-box-message">
                <h6 className='fs24 fw-700 text-dark mb-2'>Remove Cart</h6>
                <p className='mb-4 fs16 fw-500 text-dark lh_1_5'>Are you sure you want to remove this product from cart{props.module}?</p>
              </div>
              <div className="flex_item_cs gap-3">
                <Button type="button" className="button trasns_bordered small-height w-100" onClick={ConfirmModalCloseEvent}>
                  <span className="btn-text">Cancel</span>
                </Button>
                <Button type="button" className="button button-2 small-height w-100" onClick={() => { props.onClickBtn(); ConfirmModalCloseEvent(); }}>
                  <span className="btn-text">Remove</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ConfirmModel;